/* Ornesse · configurateur de mur v2 (24/10/2026). Utilisé par blocks/ai-wall-configurator.liquid. */
import { formatMoney } from '@theme/utilities';
import { CartUpdatedEvent } from '@theme/events';

function owsInit() {
  document.querySelectorAll('[data-ows]:not([data-ows-ready])').forEach(function (root) {
    root.setAttribute('data-ows-ready', '');
    var q = function (s) { return root.querySelector(s); };
    var data = {};
    try { data = JSON.parse(q('[data-ows-json]').textContent); } catch (e) {}
    var M = data.msg || {};
    var L = data.labels || {};
    var variants = data.variants || [];
    var current = variants.find(function (v) { return v.id === data.variantId; }) || variants[0];

    var wIn = q('[data-aiwc-w]');
    var hIn = q('[data-aiwc-h]');
    var warn = q('[data-ows-warn]');
    var small = q('[data-ows-small]');
    var cropBtn = q('[data-ows-crop]');
    var done = q('[data-ows-done]');
    var thumb = q('[data-ows-thumb]');
    var doneDims = q('[data-ows-done-dims]');
    var editBtn = q('[data-ows-edit]');
    var relay = q('[data-aiwc-cta]');
    var totalEl = q('[data-ows-total]');
    var detailEl = q('[data-ows-detail]');
    var addBtn = q('[data-ows-add]');
    var errEl = q('[data-ows-error]');
    var cardDims = q('[data-ows-card-dims]');
    var cardFinish = q('[data-ows-card-finish]');
    var cardTotal = q('[data-ows-card-total]');
    var sheet = q('[data-ows-sheet]');
    var frame = q('[data-ows-frame]');
    var stage = q('[data-ows-stage]');
    var img = q('[data-ows-img]');
    var box = q('[data-ows-box]');
    var rx = q('[data-ows-rx]');
    var ry = q('[data-ows-ry]');
    var hint = q('[data-ows-hint]');
    var validateBtn = q('[data-ows-validate]');
    var closeBtn = q('[data-ows-close]');
    var bar = q('[data-ows-bar]');
    var barPrice = q('[data-ows-bar-price]');
    var barBtn = q('[data-ows-bar-btn]');

    var maxH = parseFloat(root.dataset.maxH) || 0;
    var minArea = Math.max(1, parseInt(root.dataset.minArea, 10) || 1);
    var supportIndex = parseInt(root.dataset.supportIndex, 10);
    var perM2 = root.dataset.pricing !== 'fixed';
    var MIN_CM = 20;

    /* La fenêtre de cadrage et la barre mobile vivent sous <body> : position fixe fiable. */
    if (sheet) document.body.appendChild(sheet);
    if (bar) document.body.appendChild(bar);

    var state = { p: 0.5, validated: false, pendingAdd: false, ratio: 0 };

    function num(input) { var n = parseFloat(String(input.value).replace(',', '.')); return isNaN(n) ? 0 : n; }
    function dims() { return { w: num(wIn), h: num(hIn) }; }
    function valid() { var d = dims(); return d.w >= MIN_CM && d.h >= MIN_CM; }
    function tooTall() { return maxH > 0 && dims().h > maxH; }
    function rawArea() { var d = dims(); return Math.ceil((d.w * d.h) / 10000 - 1e-9); }
    function qty() { return perM2 ? Math.max(minArea, rawArea()) : 1; }
    function cm(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }
    function m2(n) { return String(n).replace('.', ',') + ' m²'; }
    function pct(n) { return String(Math.round(n * 1000) / 10).replace('.', ','); }

    function headerOffset() {
      var off = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) {
        var pos = getComputedStyle(s).position;
        if (pos === 'sticky' || pos === 'fixed') off = Math.max(off, s.getBoundingClientRect().bottom);
      });
      return Math.min(Math.max(off, 0), 220);
    }
    function scrollToEl(el) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.scrollY - headerOffset() - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    /* Ratio réel du motif à plat, lu sur l'image chargée. */
    function ensureRatio() {
      return new Promise(function (resolve) {
        if (state.ratio) return resolve();
        if (!img) { state.ratio = 1.5; return resolve(); }
        var set = function () { state.ratio = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 1.5; resolve(); };
        if (img.complete && img.naturalWidth) set();
        else { img.addEventListener('load', set, { once: true }); img.addEventListener('error', set, { once: true }); }
      });
    }

    /* Zone imprimée : la plus grande fenêtre au format du mur, déplaçable sur l'axe libre. */
    function rect() {
      var d = dims();
      if (!d.w || !d.h) return null;
      var a0 = state.ratio || 1.5;
      var aw = d.w / d.h;
      var g = aw >= a0 ? { axis: 'y', fw: 1, fh: a0 / aw } : { axis: 'x', fw: aw / a0, fh: 1 };
      g.x = g.axis === 'x' ? (1 - g.fw) * state.p : 0;
      g.y = g.axis === 'y' ? (1 - g.fh) * state.p : 0;
      g.free = g.axis === 'x' ? 1 - g.fw : 1 - g.fh;
      return g;
    }

    function paintCrop() {
      var r = rect();
      if (!r || !frame) return;
      frame.style.setProperty('--x', r.x * 100 + '%');
      frame.style.setProperty('--y', r.y * 100 + '%');
      frame.style.setProperty('--w', r.fw * 100 + '%');
      frame.style.setProperty('--h', r.fh * 100 + '%');
      var d = dims();
      rx.textContent = cm(d.w) + ' cm';
      ry.textContent = cm(d.h) + ' cm';
      var movable = r.free > 0.002;
      box.dataset.axis = r.axis;
      box.classList.toggle('is-fixed', !movable);
      stage.classList.toggle('is-fixed', !movable);
      hint.textContent = movable ? (r.axis === 'x' ? M.hintX : M.hintY) : M.hintFull;
      box.setAttribute('aria-valuenow', String(Math.round(state.p * 100)));
    }

    function paintThumb() {
      var r = rect();
      if (!r || !thumb) return;
      var d = dims();
      var aw = d.w / d.h;
      var bw = 104, bh = 78;
      var tw = aw >= bw / bh ? bw : Math.round(bh * aw);
      var th = aw >= bw / bh ? Math.round(bw / aw) : bh;
      thumb.style.width = tw + 'px';
      thumb.style.height = th + 'px';
      thumb.style.backgroundSize = 100 / r.fw + '% ' + 100 / r.fh + '%';
      thumb.style.backgroundPosition = r.axis === 'x' ? state.p * 100 + '% 50%' : '50% ' + state.p * 100 + '%';
      doneDims.textContent = cm(d.w) + ' × ' + cm(d.h) + ' cm';
    }

    function setValidated(on) {
      state.validated = on;
      done.hidden = !on;
      cropBtn.hidden = on;
      if (on) paintThumb();
    }

    function paintTotal() {
      var ok = valid() && !!current;
      var tall = tooTall();
      var d = dims();
      if (warn) warn.hidden = !tall;
      if (small) small.hidden = !((d.w > 0 && d.w < MIN_CM) || (d.h > 0 && d.h < MIN_CM));
      hIn.classList.toggle('is-invalid', tall);
      if (ok) {
        var qn = qty();
        totalEl.textContent = formatMoney(current.price * qn);
        detailEl.textContent = m2(qn) + ' ' + (perM2 && rawArea() < minArea ? M.billedMin : M.billed) + ' · ' + cm(d.w) + ' × ' + cm(d.h) + ' cm';
      } else if (current) {
        totalEl.innerHTML = formatMoney(current.price) + '<small>/m²</small>';
        detailEl.textContent = M.placeholder || '';
      }
      var sold = current && !current.available;
      addBtn.textContent = sold ? data.soldOut : data.addLabel;
      addBtn.classList.toggle('is-off', !ok || tall || sold);
      addBtn.setAttribute('aria-disabled', String(!ok || tall || sold));
      paintBar();
    }

    function paintBar() {
      if (!bar) return;
      var ok = valid() && !!current && !tooTall();
      barPrice.textContent = ok
        ? formatMoney(current.price * qty()) + ' · ' + m2(qty())
        : (data.fromLabel ? data.fromLabel + ' ' : '') + formatMoney(current ? current.price : 0) + '/m²';
      barBtn.textContent = ok ? data.addLabel : data.stickyLabel;
    }

    function markInvalid() {
      [wIn, hIn].forEach(function (i) { i.classList.toggle('is-invalid', num(i) < MIN_CM); });
      var first = num(wIn) < MIN_CM ? wIn : hIn;
      scrollToEl(cardDims);
      setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 350);
    }

    function openSheet() {
      if (!valid()) { markInvalid(); return; }
      if (tooTall()) { scrollToEl(cardDims); return; }
      ensureRatio().then(function () {
        validateBtn.textContent = state.pendingAdd ? M.validateAdd : M.validate;
        if (typeof sheet.showModal === 'function') sheet.showModal(); else sheet.setAttribute('open', '');
        document.documentElement.classList.add('ows-lock');
        requestAnimationFrame(paintCrop);
      });
    }
    function closeSheet() {
      if (sheet.open && typeof sheet.close === 'function') sheet.close(); else sheet.removeAttribute('open');
      document.documentElement.classList.remove('ows-lock');
    }

    [wIn, hIn].forEach(function (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/[^0-9.,]/g, '');
        input.classList.remove('is-invalid');
        if (state.validated) setValidated(false);
        paintTotal();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); if (input === wIn) hIn.focus(); else openSheet(); }
      });
    });

    cropBtn.addEventListener('click', openSheet);
    editBtn.addEventListener('click', openSheet);
    closeBtn.addEventListener('click', closeSheet);
    sheet.addEventListener('close', function () { document.documentElement.classList.remove('ows-lock'); state.pendingAdd = false; });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });

    validateBtn.addEventListener('click', function () {
      var go = state.pendingAdd;
      setValidated(true);
      closeSheet();
      if (go) addToCart();
      else scrollToEl(cardFinish || cardTotal);
    });

    /* Déplacement de la zone imprimée : on glisse n'importe où sur l'image. */
    var drag = null;
    function startAt(e, r) {
      var b = stage.getBoundingClientRect();
      var size = r.axis === 'x' ? b.width : b.height;
      var f = r.axis === 'x' ? (e.clientX - b.left) / b.width : (e.clientY - b.top) / b.height;
      var lo = r.axis === 'x' ? r.x : r.y;
      var len = r.axis === 'x' ? r.fw : r.fh;
      if (f < lo || f > lo + len) {
        state.p = Math.min(1, Math.max(0, (f - len / 2) / r.free));
        paintCrop();
      }
      drag = { id: e.pointerId, axis: r.axis, start: r.axis === 'x' ? e.clientX : e.clientY, p0: state.p, span: size * r.free };
    }
    stage.addEventListener('pointerdown', function (e) {
      var r = rect();
      if (!r || r.free <= 0.002) return;
      e.preventDefault();
      startAt(e, r);
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      stage.classList.add('is-drag');
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id || !drag.span) return;
      var pos = drag.axis === 'x' ? e.clientX : e.clientY;
      state.p = Math.min(1, Math.max(0, drag.p0 + (pos - drag.start) / drag.span));
      paintCrop();
    });
    function endDrag(e) { if (drag && e.pointerId === drag.id) { drag = null; stage.classList.remove('is-drag'); } }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    box.addEventListener('keydown', function (e) {
      var r = rect();
      if (!r) return;
      var step = { ArrowLeft: -0.05, ArrowUp: -0.05, ArrowRight: 0.05, ArrowDown: 0.05 }[e.key];
      if (step === undefined) return;
      e.preventDefault();
      state.p = Math.min(1, Math.max(0, state.p + step));
      paintCrop();
    });
    window.addEventListener('resize', function () { if (sheet.open) paintCrop(); });

    /* Finition : l'option « Support » choisit la variante (prix au m²). */
    root.querySelectorAll('[data-ows-support]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked || !current) return;
        var chosen = current.options.slice();
        chosen[supportIndex] = radio.value;
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
        if (match) {
          current = match;
          document.dispatchEvent(new CustomEvent('ai:variant-change', { detail: { variant: match } }));
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) {}
        }
        root.querySelectorAll('[data-ows-finish]').forEach(function (p) { p.hidden = p.getAttribute('data-ows-finish') !== radio.value; });
        paintTotal();
      });
    });

    /* Retour de « Voir sur mon mur » : dimensions remplies, on montre le configurateur. */
    relay.addEventListener('click', function () { paintTotal(); scrollToEl(cardDims); });

    /* Finition repliée : finitions et prix visibles, explications au clic (bouton + ou choix d'une finition). */
    var moreBtn = q('[data-ows-more-btn]');
    var more = q('[data-ows-more]');
    function setMore(open) {
      if (!more || !moreBtn) return;
      more.hidden = !open;
      moreBtn.setAttribute('aria-expanded', String(open));
    }
    if (moreBtn) moreBtn.addEventListener('click', function () { setMore(more.hidden); });
    root.querySelectorAll('.ows__seg-opt').forEach(function (opt) {
      opt.addEventListener('click', function () { setMore(true); });
    });

    function addToCart() {
      if (!valid()) { markInvalid(); return; }
      if (tooTall()) { scrollToEl(cardDims); return; }
      if (!current || !current.available) return;
      if (!state.validated) { state.pendingAdd = true; openSheet(); return; }
      var r = rect();
      var d = dims();
      var props = {};
      props[L.w || 'Largeur'] = cm(d.w) + ' cm';
      props[L.h || 'Hauteur'] = cm(d.h) + ' cm';
      if (perM2) props[L.area || 'Surface'] = m2(qty());
      if (L.crop) props[L.crop] = M.cropValue || 'Validé sur l’aperçu';
      if (r) props['_Zone imprimée'] = 'x ' + pct(r.x) + '–' + pct(r.x + r.fw) + ' % · y ' + pct(r.y) + '–' + pct(r.y + r.fh) + ' % du motif';
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.dataset.sectionId ? drawer.dataset.sectionId : '';
      addBtn.classList.add('is-loading');
      errEl.hidden = true;
      fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: qty(), properties: props }], sections: sections })
      })
        .then(function (res) { return res.json(); })
        .then(function (res) {
          if (res.status && res.description) throw new Error(res.description);
          var icon = document.querySelector('cart-icon');
          var count = icon && icon.getCurrentItemCount ? (icon.getCurrentItemCount() || 0) + qty() : undefined;
          if (sections) {
            document.dispatchEvent(new CartUpdatedEvent({}, { itemCount: count, source: 'ai-wall-configurator', sections: res.sections }));
          } else {
            window.location.href = Theme.routes.cart_url;
          }
        })
        .catch(function (err) {
          errEl.textContent = err && err.message ? err.message : String(err);
          errEl.hidden = false;
        })
        .finally(function () { addBtn.classList.remove('is-loading'); });
    }
    addBtn.addEventListener('click', addToCart);

    /* Barre fixe mobile : visible une fois le configurateur dépassé. */
    if (bar) {
      var mq = window.matchMedia('(max-width: 749px)');
      var syncBar = function () {
        var b = root.getBoundingClientRect();
        bar.hidden = !mq.matches || b.bottom > 0 || (sheet && sheet.open);
      };
      window.addEventListener('scroll', syncBar, { passive: true });
      if (mq.addEventListener) mq.addEventListener('change', syncBar);
      barBtn.addEventListener('click', function () {
        if (valid() && !tooTall()) addToCart();
        else markInvalid();
      });
      syncBar();
    }

    paintTotal();
  });
}

owsInit();
document.addEventListener('shopify:section:load', owsInit);
